import {Injectable} from '@angular/core';
import {firstValueFrom, Observable} from "rxjs";
import {ClaimDiscountCodeResponseDto} from "../model/discount/ClaimDiscountCodeResponseDto";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {LoggingService} from "../../../../core/service/logging.service";
import {PendingDiscountDto} from "../model/discount/PendingDiscountDto";
import {RedeemDiscountCodeDto} from "../model/discount/RedeemDiscountCodeDto";
import {ClaimDiscountCodeDto} from "../model/discount/ClaimDiscountCodeDto";
import {environment} from "../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class DiscountService {

    private apiUrl = environment.apiUrl;

    constructor(private readonly http: HttpClient,
                private readonly logger: LoggingService) {
    }

    async checkCouponAvailability(couponId: string): Promise<ClaimDiscountCodeResponseDto> {
        try {
            return await firstValueFrom(
                this.claimDiscount({ discountCode: couponId, type:'COUPON' })
            );
        } catch (error) {
            this.logger.error(`Error claiming coupon: ${couponId}`, error as HttpErrorResponse);
            return undefined;
        }
    }

    private async getPromoAvailability(promoCode: string): Promise<ClaimDiscountCodeResponseDto> {
        try {
            return await firstValueFrom(
                this.claimDiscount({ discountCode: promoCode, type:'PROMO' })
            );
        } catch (error) {
            this.logger.error(`Error claiming promo: ${promoCode}`, error as HttpErrorResponse);
            return undefined;
        }
    }


    getPendingDiscount(): Observable<PendingDiscountDto> {
        return this.http.get<PendingDiscountDto>(`${this.apiUrl}/discounts/pendings/current`);
    }

    setPendingDiscount(discountCode: RedeemDiscountCodeDto): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/discounts/pendings`, discountCode);
    }

    removePendingDiscount(): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/discounts/pendings/current`);
    }

    claimDiscount(discountCode: ClaimDiscountCodeDto): Observable<ClaimDiscountCodeResponseDto> {
        return this.http.post<ClaimDiscountCodeResponseDto>(`${this.apiUrl}/discounts/claims`, discountCode);
    }
}
